import {AfterViewInit, Component, OnInit} from '@angular/core';
import {NewsService} from "../../services/news.service";
import {ActivatedRoute} from "@angular/router";
declare var $:any;
@Component({
  selector: 'app-videos-component',
  templateUrl: './videos-component.component.html',
  styleUrls: ['./videos-component.component.css']
})
export class VideosComponentComponent implements OnInit, AfterViewInit {

  content:any=[{menu:''}];
  documentos:any=[];
  videos:any=[];
  domain: string;
  data:any;
  styles: any= [
    {uri: '/assets/video/css/stellar.css'},
    {uri: '/assets/video/css/stellar-font-awesome.css'},
    {uri: '/assets/video/css/jquery.mCustomScrollbar.css'}
  ];

  constructor(private news: NewsService, private route: ActivatedRoute) {
    this.route.params.subscribe( params => {
      this.getContent(params.id);
    });
  }
  getUid(param){
    var re = /.+embed\//;
    var  newstr = param.split(re);
    var re = /\?feature.+/;
    var  newstr = newstr[1].split(re);
    return newstr[0];
  }
  ngOnInit() {



  }
  getContent(id) {
    this.news.getContent(id).subscribe(response => {

        this.content= response;
        console.log('CONTENT', response);


      },
      error => {
        console.log(<any>error);
      });
  }
  ngAfterViewInit() {
    let head: any = document.getElementsByTagName('head').item(0);

    this.styles.forEach((currentValue, index, array) => {
      let script: any = document.createElement('link');
      script.setAttribute('rel', 'stylesheet');
      script.setAttribute('type', 'text/css');
      script.setAttribute('href', currentValue.uri);
      head.appendChild(script);
    });
    //console.log('HEADERS',head);
    this.news.getVideos().subscribe(response => {
        this.videos = response;
        console.log('VIDEOS', this.videos);
        this.videos.forEach((currentValue, index, array)=>{
          this.data.videos.push({
            videoType:"youtube",
            title:"",
            youtubeID:currentValue.Archivo,
            youtubeIDStartSeconds: "",
            youtubeIDEndSeconds: "",
            imageUrl:"https://img.youtube.com/vi/"+currentValue.Archivo+"/default.jpg",
            imageTimer:4,
            description:currentValue.Descripcion,
            thumbImg:"https://img.youtube.com/vi/"+currentValue.Archivo+"/default.jpg",
            info:currentValue.Descripcion
          });
        });
        setTimeout(()=> {
          $("#Stellar_video_player").Video(this.data);},1000
        );

      },
      error => {
        console.log(<any>error);
      });
    this.news.getNews().subscribe(response => {
        this.documentos = response[1];
        console.log('=>', this.documentos);
      },
      error => {
        console.log(<any>error);
      });

    this.news.getConfig().subscribe(response => {
        console.log('FILE_JSON', response);
        this.domain = response.back_domain;
      },
      error => {
        console.log(<any>error);
      });
    this.data={
      instanceName:"player1",
      instanceTheme:"dark",
      playerLayout: "fitToContainer",
      playerOrientation:"LTR",
      autohideControls:5,
      hideControlsOnMouseOut:false,
      videoPlayerWidth:768,
      videoPlayerHeight:432,
      videoRatio: 16/9,
      autoplay:false,
      colorAccent:"#ff0000",
      videoAnimationTime: 350,
      playSpecificVideo: 0,
      progressBarThickness: 3,
      progressBarThicknessOnMouseover: 6,
      tooltipFontSize:12,
      videoPlayerShadow:"effect1",
      loadRandomVideoOnStart:false,
      shuffle:false,
      onFinish:"Play next video",
      nowPlayingText:true,
      showAllControls:true,
      allowSkipAd:true,
      infoShow:true,
      nextShow:true,
      rewindShow:true,
      qualityShow:true,
      //<!-- LIGHTBOX SETTINGS -->
      lightBox:false,
      lightBoxAutoplay: false,
      lightBoxThumbnailWidth: 400,
      lightBoxThumbnailHeight: 220,
      lightBoxCloseOnOutsideClick: true,
      //<!-- PLAYLIST SETTINGS -->
      playlist:"Right playlist",
      playlistScrollType:"inset",
      playlistBehaviourOnPageload:"opened (default)",
      //<!-- YOUTUBE SETTINGS -->
      youtubeControls:"custom controls",
      youtubeSkin:"light",
      youtubeColor:"white",
      youtubeQuality:"default",
      youtubeShowRelatedVideos:true,
      //<!-- SHARE SETTINGS  -->
      shareShow:true,
      facebookShow:true,
      twitterShow:true,
      googlePlusShow:true,
      facebookShareName:"Stellar video player",
      facebookShareLink:"http://www.planificacion.gob.bo/video",
      facebookShareDescription:"test.",
      facebookSharePicture:"",
      twitterText:"video",
      twitterLink:"http://www.planificacion.gob.bo/video",
      twitterHashtags:"wordpressvideoplayer",
      twitterVia:"Creative media",
      googlePlus:"http://codecanyon.net/",
      //<!-- EMBED SETTINGS  -->
      embedShow:true,
      embedCodeSrc:"www.yourwebsite.com/videoplayer/index.html",
      embedShareLink:"www.yourwebsite.com/videoplayer/index.html",
      videos:[]
    };

  }

}



// WEBPACK FOOTER //
// ./src/app/components/videos-component/videos-component.component.ts